import dark from './dark';
import breakpoints from './breakpoints';

export default {
  dark: Object.assign({ name: 'dark' }, dark, { breakpoints }),
};
